import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getInvoiceHeaderList } from '../../../../../api/billing-center/invoice';
import { CommonButton } from '../../../../../components/button/main';
import { CommonCard } from '../../../../../components/card';
import getFormatMessage from '../../../../../locales/get-format-message';
import { IAPICompanyFullInfo } from '../../../../../model/api-modules';
import { IAPIInvoiceHeader } from '../../../../../model/api-modules/bill-center/invoice';
import { IRootState } from '../../../../../store/reducers';
import { getInvoiceTypeText } from '../lib';
import { AddModifyInvoiceDrawer } from './drawer';
import styles from './index.module.scss';

interface IProps {
  readonly companyInfo: IAPICompanyFullInfo;
  readonly onChange: (data: IAPIInvoiceHeader) => void;
}

export const InvoiceHeader = (props: IProps) => {
  const { companyInfo, onChange } = props;
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const [invoice, setInvoice] = useState<IAPIInvoiceHeader>();

  useEffect(() => {
    init();
  }, [selectStudio?.studioID]);

  const init = async (headerInfo?: IAPIInvoiceHeader) => {
    if (!selectStudio) {
      return;
    }

    const res =
      headerInfo || (await getInvoiceHeaderList(selectStudio.studioID));
    if (res) {
      setInvoice(res);
      onChange(res);
    }
  };

  return (
    <>
      <CommonCard
        title={getFormatMessage('invoice_header_title')}
        extra={
          <CommonButton onClick={() => setShowDrawer(true)}>
            {getFormatMessage('manage_invoice_header')}
          </CommonButton>
        }
      >
        <div className={styles.cardBody}>
          <div>
            <span className={styles.label}>
              {getFormatMessage('invoice_type')}：
            </span>
            {getInvoiceTypeText(invoice?.invoice_type)}
          </div>
          <div>
            <span className={styles.label}>
              {getFormatMessage('invoice_header_name')}：
            </span>
            {invoice?.invoice_name}
          </div>
          <div>
            <span className={styles.label}>
              {getFormatMessage('invoice_header_code')}：
            </span>
            {invoice?.identification_code}
          </div>
        </div>
      </CommonCard>
      {showDrawer && (
        <AddModifyInvoiceDrawer
          companyInfo={companyInfo}
          invoiceInfo={invoice}
          onClose={() => {
            setShowDrawer(false);
          }}
          onChange={(newInfo) => {
            init(newInfo);
            setShowDrawer(false);
          }}
        />
      )}
    </>
  );
};
